import { memo as j, useMemo as v } from "react";
import { SvgRgObjectText as y } from "./index5.js";
import { get2dRgObjectValues as O } from "./index2.js";
import { jsx as c, jsxs as f, Fragment as R } from "react/jsx-runtime";
const u = j(({
  obj: t,
  scale: i,
  showImage: n,
  showCustom: o,
  showText: e,
  mx: d
}) => {
  const {
    pos: p,
    size: a,
    rotation: g,
    anchor: s,
    angle: $
  } = v(() => O({
    obj: t,
    mx: d
  }), [t, d]), {
    customFill: l,
    ...r
  } = !n || typeof n == "boolean" ? {
    customFill: void 0
  } : n;
  let m;
  return r && !l ? m = r.fill !== void 0 ? r.fill : t.color : l && (m = l(t)), /* @__PURE__ */ c("g", {
    "data-name": t.name,
    transform: [`translate(${p.join(",")})`].join(" "),
    children: /* @__PURE__ */ f("g", {
      "data-name": "wrapper",
      transform: [`translate(${s.join(",")})`, `rotate(${g.join(" ")})`].join(" "),
      children: [n && r && /* @__PURE__ */ c("rect", {
        width: a[0],
        height: a[1],
        ...r,
        fill: m
      }), (e || o) && /* @__PURE__ */ f("g", {
        "data-name": "center",
        transform: [`translate(${a[0] * 0.5},${a[1] * 0.5})`, `rotate(${Math.abs($ % 360) > 90 ? 180 : 0})`].join(","),
        children: [o && o({
          obj: t,
          scale: i
        }), e && /* @__PURE__ */ f(R, {
          children: [typeof e == "boolean" && /* @__PURE__ */ c(y, {
            obj: t,
            scale: i
          }), typeof e != "boolean" && e({
            obj: t,
            scale: i
          })]
        })]
      })]
    })
  });
});
u.displayName = "SvgRgObject";
export {
  u as SvgRgObject
};
//# sourceMappingURL=index6.js.map
